import { api } from './axios'

export interface ResellerInvitationInfoDto {
  email: string
  firstName: string
  lastName: string
  isExpired: boolean
  isAccepted: boolean
}

export interface AcceptResellerInvitationDto {
  invitationCode: string
  password: string
}

// Get reseller invitation info (public)
export const getResellerInvitationInfo = async (
  invitationCode: string,
): Promise<ResellerInvitationInfoDto> => {
  const response = await api.get(`/resellers/invitation/${invitationCode}`)
  return response.data
}

// Accept reseller invitation (public)
export const acceptResellerInvitation = async (
  data: AcceptResellerInvitationDto,
): Promise<{ message: string }> => {
  const response = await api.post('/resellers/invitation/accept', data)
  return response.data
}
